<app-header (found)="handleResults($event)"></app-header>
<div id="main-wrapper">
  <ngx-loading
    [show]="loadingDashboard"
    [config]="{ backdropBorderRadius: '14px' }"
  ></ngx-loading>
  <div class="main-background topSpace main-container epahafContainer">
   <app-search-results [resultGridList]="data"></app-search-results> 
    <div class="container-fluid dashboardViewEpahaf" style="padding: 0">
      <div class="tab homeAccrordian">
        <!-- <ul class="nav nav-tabs cup-detail-header panelHeading" role="tablist">
          <li role="presentation" class="active">
            <a
              class="epahaf-logo"
              href="#Section1"
              aria-controls="home"
              role="tab"
              data-toggle="tab"
              >PAHAF</a
            >
          </li>
          <div class="pull-right workflow">	
            To know more about <strong>PAHAF Workflow</strong> <a (click)="viewPAHAFWorkflowDoc()"
            href="javascript:void(0);"><u> View PDF </u></a>	
          </div>
        </ul> -->
        <div class="row">
            <div class="col-md-8">
              <h1 class="carelon-page-title">PAHAF</h1>
            </div>
            <div class="col-md-4 d-flex justify-content-end align-items-center">
              <span >
                To know more about <strong>PAHAF Workflow</strong> <a (click)="viewPAHAFWorkflowDoc()"
                href="javascript:void(0);" style="color: #006bd6;"><u> View PDF </u></a>
              </span>
            </div>
        
          
         
        
          <!-- <div class="pull-right workflow">	
            To know more about <strong>PAHAF Workflow</strong> <a (click)="viewPAHAFWorkflowDoc()"
            href="javascript:void(0);"><u> View PDF </u></a>	
          </div> -->
        </div>

        <div class="pahaf-info-alert" style="margin-top: 18px; margin-bottom: 18px;"*ngIf="warningsMsgs.length>0">
  <div [ngStyle]="{'padding-bottom': !showPahafInfo ? '4px' : '0'}">
    <div style="display: flex; justify-content: space-between; align-items: flex-start; background: #fff4f4; border-radius: 8px 8px 0 0; padding: 14px 18px;">
      <span class="blink-important" style="font-weight: 700; font-size: 16px;">
        <span style="color: #e53935; font-weight: 700;">Important</span>
        <span style="color: #231e33; font-weight: 700;"> | </span>
        <span style="color: #231e33; font-weight: 700;"[innerHTML]="warningsMsgs[0]?.messageName" ></span>
      </span>
      <a class="pahaf-toggle-link" (click)="showPahafInfo = !showPahafInfo"
         style="color: #231e33; font-weight: 400; cursor: pointer; min-width: 80px; text-align: right; font-size: 14px;">
        {{ showPahafInfo ? 'View Less' : 'View More' }}
      </a>
    </div>
    <ng-container *ngIf="showPahafInfo">
      <div style="color: #231e33; background: #fff; padding: 16px 18px 10px 18px; border-radius: 0 0 8px 8px;">
         <div style="font-size: 15px; font-weight: 400;"  [innerHTML]="warningsMsgs[0]?.message"></div>
        </div>
       
    </ng-container>
  </div>
</div>


        <div class="epahafContent whiteBg ">
          <div class="row">
            <div class="heading memberDetailshead col-md-2">
              Member Details
            </div>
            <div class="col-md-10 d-flex justify-content-end rightPad0 pad0 marginTop">
                     
              <div class="form-group rightPad0">
                <div class = "bothBtnstyle pull-right">
                  <span
                   *ngIf=" allUnreadAlertCount!== 0" 
                    class="unread-message-count-gen-dashboard"
                    >{{allUnreadAlertCount }}</span>
                     <!-- <button type="button" class="btn btn-default download-pdf" (click)="chunkDownload()">
                      <i class="fa fa-pie-chart" style="color: #23499E;"></i>Download PDF</button>  -->

                      <!-- <button type="button" class="btn btn-default download-pdf" [disabled]="!unselectFlag" data-bs-toggle="modal" 
                        data-bs-target="#confirmModal">
                      <i class="fa fa-pie-chart" style="color: #23499E;"></i>Download PDF</button>                  -->

                       <button type="button" class="generateMemberRosterBtn" data-bs-toggle="modal" 
                        data-bs-target="#confirmModal" (click)="openBulkDownloadModal()">
                      <i class="generateMemberRosterBtn" style="color: #23499E;"></i>BULK PDF Download </button>                 

                  <button
                  class="btn blue reportBtnblue generatePDFBtn"  (click)="AlertAction()" [disabled]="!allUnreadAlertCount"
                  title="All unread Notifications"
                >
                <i class="fa fa-bell-o bell-con-move"></i>
                </button>
                <button
                  class="generateMemberRosterBtn"
                  (click)="generateRosterDoc()"
                  title="Click here to generate a consolidated PDF for members"
                >
                  Generate Member Roster<span class="dBlock"></span
                  >
                </button>
                </div>
              </div>
            </div>
          </div>
          <hr>

          <div class="row">
              <div  class="col-md-12 col-xs-12 ">
                <div class="row">
                  <div class="col-xs-12 col-md-3 form-group filterByDuration pad0" style="display: grid">
                    <label for="memberHealthPlan">FILTER BY PAHAF STATUS</label>
                    <div class="filter-by-pahaf-status">
                      <angular2-multiselect [data]="dropdownList" [(ngModel)]="selectedPahafStatus"
                      
                        class="multiselect-dropdown-style form-control input-underline  no-border" [settings]="dropdownSettings" 
                        (onSelect)="onItemSelect($event)" (onDeSelect)="OnItemDeSelect($event)"
                        (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)">
                      </angular2-multiselect>
                    </div>
                  </div>

                  <div class="col-xs-12 col-md-3 form-group filterByDuration pad0" style="display: grid">
                    <label for="memberHealthPlan">FILTER BY REFRESH STATUS</label>
                    <div class="filter-by-pahaf-status">
                      <angular2-multiselect [data]="dropdownListRefresh" [(ngModel)]="selectedPahafStatusRefresh"
                      
                        class="multiselect-dropdown-style form-control input-underline  no-border" [settings]="dropdownSettings"  [disabled]="isSecondDropdownDisabled"  [class.disabled-dropdown]="isSecondDropdownDisabled" 
                        (onSelect)="onItemSelect1($event)" (onDeSelect)="OnItemDeSelect1($event)"
                        (onSelectAll)="onSelectAll1($event)" (onDeSelectAll)="onDeSelectAll1($event)">
                      </angular2-multiselect>
                    </div>
                  </div>
  
                  <div class="col-xs-12 form-group col-md-3 pad0" style="position: relative">
                    <div>
                      <label for="provider" class="searchMember-label">SEARCH MEMBER NAME / ID / PCP</label>
                      <input class="form-control input-underline searchMember" placeholder="Search any Member / PCP"
                        [(ngModel)]="searchInput" (keyup)="filterMembers($event)" style="padding: 10px;"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-xs-12 "></div>
              <div class="col-md-6 col-xs-12 pdfmarginTop">
               <div class="row">
                <div class="col-md-12 col-xs-12 d-flex justify-content-end align-items-end">
                 
                    <button type="button" class="btn btn-default previewBtn" [disabled]="checkedList.length == 0" (click)="checkedList.length >0 && priviewPdf()"><img class="pdfIcon" src="../../../assets/images/DocumentIcon.svg" alt="pdf Icon" >Preview PAHAF Details</button>
                 
                 
                    <button type="button" class="btn btn-default viewChartBtn" (click)="getChart()"><i class="fa fa-pie-chart" style="color: #23499E;"></i>View Chart</button>
                 
                </div>
             
              <div class="col-md-12 col-xs-12 p-0">
                <div class=" pdfmargin-top row">
                  <div class="col-md-1 m-0 p-0"></div>
                  <div class="col-md-11" style="text-align: end; padding-right: 22px;">
                  <span class="pe-2">
                    <img src="assets/images/Square.svg" alt="" class="svgsizes">
                    <!-- <i class="fa fa-square-o" style="background-color:rgb(234, 234, 245);border-radius:10px"></i> -->
                    Conditions Pending Assesment</span>
                  <span class="pe-2">
                    <img src="assets/images/Triangle.svg" alt="" class="svgsizes">
                    <!-- <i class="fa fa-caret-up"></i> -->
                    Quality Measures Count</span>
                  <span class="">
                    <img src="assets/images/Circle.svg" alt="" class="svgsizes">
                    <!-- <i class="fa fa-circle-o" style="background-color:rgb(234, 234, 245);border-radius:10px"></i> -->
                    Total Count</span>
                    

                    </div>
                </div>
              </div>
               </div>
            </div>
          </div>
          <div class="memberContainer dashboard-content mainEpahafTable">
            <table
              class="table custom-table myTable stcikyHeaders"
              id="myTable"
            >
              <thead>
                <tr class="table-header stickyHeader">
                  <!-- <th>Index</th>-->
                  <!-- <th></th> -->
                  <th class="checkBoxContainer" style="width: 7em">
                    SELECT TO <span class="nextLine">GENERATE PDF</span>
                    <!-- <div>
                      <input
                        type="checkbox"
                        class="custom-control-input checkboxinput"
                        (change)="selectUnselectAll($event)"
                        [(ngModel)]='unselectFlag'
                      />
                    </div> -->
                  </th>
                  <th class="hidden-sm hidden-xs" >
                    PCP
                    <i (click)="onSortClick($event,'pcpName')" 
                      scope="col" 
                      appSortCustom
                      [appSortCustom]="virtualLoadingMemberDetailData"
                      sortOrder="asc"
                      sortField="pcpName"
                      class="fa fa-fw fa-sort"
                    ></i>
                  </th>
                  <th>MEMBER ID</th>
                  <th   class="hidden-sm hidden-xs">
                    MEMBER NAME<i (click)="onSortClick($event,'memberFirstName')"
                      scope="col"  appSortCustom
                      [appSortCustom]="virtualLoadingMemberDetailData"
                      sortOrder="asc"
                      sortField="memberFirstName"
                      class="fa fa-fw fa-sort"
                    ></i>
                  </th>
                  <th class="hidden-sm hidden-xs">DATE OF BIRTH</th>
                  <!-- //<th class="hidden-sm hidden-xs">NOTIFICATION FLAG</th> -->
                  
                  <th class="hidden-sm hidden-xs">Member Contact Number</th>
                  <th class="hidden-sm hidden-xs">   </th>
                  <th class="hidden-sm hidden-xs">   </th>
                  <th class="hidden-sm hidden-xs">
                    Total
                    <!-- <i scope="col"
                      [appSort]="virtualLoadingMemberDetailData"
                      data-order="asc" 
                      data-name="total"
                      class="fa fa-fw fa-sort"
                    ></i> -->
                  </th>
                  <th class="hidden-sm hidden-xs"> PAHAF STATUS </th>
                  <th class="hidden-sm hidden-xs">Status Date</th>
                  <th class="hidden-sm hidden-xs">refresh Status</th>                  
                </tr>
              </thead>
              <tbody class="panels">
               
                <ng-container
                  *ngFor="
                    let memberDetails of virtualLoadingMemberDetailData;
                    index as rowIndex
                  "
                >
                  <ng-container *ngIf="memberDetails.memberHmoID; else noMemberDetails">
                    <tr
                      class="accordion-toggle rows"
                      data-parent="#myTable"
                      [attr.data-num]="rowIndex"
                     
                      [ngClass]="indexOfClickedRow == rowIndex ? 'rowSelected':'rowUnSelected'"
                    >
                      <td class="checkBoxContainer">
                    <input
                      type="checkbox"
                      class="custom-control-input checkboxinput"
                      #checkboxesSelect (click)="$event.stopPropagation() "
                      [checked]="isChecked(memberDetails.memberHmoID)"
                      (change)="selectedMember(memberDetails, '', $event)"
                    />
                  </td>
                  <td style="cursor: pointer"  (click)="rowSelectionEpahaf($event, memberDetails)">
                    {{ memberDetails.pcpName }}
                    <!-- <div #demo id ="demo" ><app-pahaf-form></app-pahaf-form>
                    </div> -->
                  </td>
                      <td style="cursor: pointer"  (click)="rowSelectionEpahaf($event, memberDetails)">
                        {{ memberDetails.memberHmoID }}
                      </td>
                      <td style="cursor: pointer"  (click)="rowSelectionEpahaf($event, memberDetails)">
                        {{
                          memberDetails.memberFirstName 
                        }}
                      </td>
                      <td style="cursor: pointer"  (click)="rowSelectionEpahaf($event, memberDetails)">
                        {{ memberDetails.memberDOB }}
                      </td>
                      
                      <td style="cursor: pointer"  (click)="rowSelectionEpahaf($event, memberDetails)">
                        {{ memberDetails.memberContactNumber }}
                      </td>
                      <td style="text-align: left; width: 50px">
                        <span>
                          <img class="svgsize" src="assets/images/Square.svg" alt="" class="svgsizes" data-toggle="tooltip" title="Conditions Pending Assesment"></span>{{memberDetails.conditionCount}}</td>
                      <td style="text-align: left; width: 50px;">
                        <span>
                          <img class="svgsize" src="assets/images/Triangle.svg" alt="" class="svgsizes" data-toggle="tooltip" title="Quality Measures Count"></span>{{getQualityMeasureCount(memberDetails.pcpId,memberDetails.memberHmoID)}}</td>                          
                      <td style="text-align: left">
                        <span>
                          <img class="svgsize" src="assets/images/Circle.svg" alt="" class="svgsizes" data-toggle="tooltip" title="Total(Conditions Pending Assesment + Quality Measures Count)"></span>{{memberDetails.conditionCount + getCount(memberDetails.pcpId,memberDetails.memberHmoID) }}</td>
                      <td
                        *ngIf="memberDetails.status === 'Not Received'"
                        style="cursor: pointer;text-align: left;width: 20%;" class="status-grey"
                        >
                        {{memberDetails.status}}<i class="fa fa-flag incomplete"></i><i class="fa fa-upload fileupload" (click)="uploadDocuments(rowIndex,memberDetails.memberHmoID)"></i>
                      </td>
                      <td 
                      *ngIf="memberDetails.status === 'Pending Coder Review'"
                      style="cursor: pointer;text-align: left;width: 20%;" class="status-blue"
                      data-toggle="tooltip" title={{memberDetails.mode}}
                        (mouseover)="hoveringMethod(rowIndex)"
                        (mouseleave)="hoveringVal()"
                      >{{memberDetails.status}}
                        <div class="checkiconStyle">
                          <div>
                            <span>
                              <div class="alignnIcon">
                                <div class="DocIconStyle" >
                                  <span
                                    data-bs-toggle="collapse"
                                    [attr.data-bs-target]="'#demo' + rowIndex" 
                                  >
                                    <i
                                      class="fa fa-file-text-o completeCheck"
                                      (click)="
                                        showDoc(
                                          rowIndex,
                                          memberDetails.memberHmoID
                                        )
                                      "
                                    ></i>
                                  </span>
                                </div>
                              </div>
                            </span>
                          </div>
                        </div>
                      </td>         
                      <td 
                      *ngIf="memberDetails.status === 'Payment Approved'"
                      style="cursor: pointer;text-align: left;width: 20%;"  class="status-lightGreen"
                      data-toggle="tooltip" title={{memberDetails.mode}}
                        (mouseover)="hoveringMethod(rowIndex)"
                        (mouseleave)="hoveringVal()"
                      >{{memberDetails.status}}
                        <div class="checkiconStyle">
                          <div>
                            <span>
                              <div class="alignnIcon">
                                <div class="DocIconStyle" >
                                  <span
                                    data-bs-toggle="collapse"
                                    [attr.data-bs-target]="'#demo' + rowIndex" 
                                  >
                                    <i
                                      class="fa fa-file-text-o completeCheck"
                                      (click)="
                                        showDoc(
                                          rowIndex,
                                          memberDetails.memberHmoID
                                        )
                                      "
                                    ></i>
                                  </span>
                                </div>
                              </div>
                            </span>
                          </div>
                        </div>
                      </td>   
                      <td 
                      *ngIf="memberDetails.status === 'Paper PAHAF In Progress'"
                      style="cursor: pointer;text-align: left;width: 20%;"  class="status-line"
                      data-toggle="tooltip" title={{memberDetails.mode}}
                        (mouseover)="hoveringMethod(rowIndex)"
                        (mouseleave)="hoveringVal()"
                      >{{memberDetails.status}}
                        <div class="checkiconStyle">
                          <div>
                            <span>
                              <div class="alignnIcon">
                                <div class="DocIconStyle" >
                                  <span
                                    data-bs-toggle="collapse"
                                    [attr.data-bs-target]="'#demo' + rowIndex" 
                                  >
                                    
                                  </span>
                                </div>
                              </div>
                            </span>
                          </div>
                        </div>
                      </td>   
                      <td 
                      *ngIf="memberDetails.status === 'Denied'"
                      style="cursor: pointer;text-align: left;width: 20%;" class="status-Red"

                      data-toggle="tooltip" title="Mode : '{{memberDetails.mode}}' &#013;Declined Reason : '{{memberDetails.denialReason}}'"
                        (mouseover)="hoveringMethod(rowIndex)"
                        (mouseleave)="hoveringVal()"
                      >{{memberDetails.status}}
                        <div class="checkiconStyle">
                          <div>
                            <span>
                              <div class="alignnIcon">
                                <div class="DocIconStyle" >
                                  <span
                                    data-bs-toggle="collapse"
                                    [attr.data-bs-target]="'#demo' + rowIndex" 
                                  >
                                    <i
                                      class="fa fa-file-text-o completeCheck"
                                      (click)="
                                        showDoc(
                                          rowIndex,
                                          memberDetails.memberHmoID
                                        )
                                      "
                                    ></i>
                                  </span>
                                </div>
                              </div>
                            </span>
                          </div>
                        </div>
                        <div class="checkiconStyle">
                          <div>
                            <span>
                              <div class="alignnIcon1">
                                <i class="fa fa-upload fileupload" (click)="uploadDocuments(rowIndex,memberDetails.memberHmoID)"></i>
                              </div>
                            </span>
                          </div>                          
                        </div>
                      </td>   

                      <td 
                      *ngIf="memberDetails.status === 'Portal In Progress'"
                      style="cursor: pointer;text-align: left;width: 20%;" class="status-grey1"

                      data-toggle="tooltip" title="Mode : '{{memberDetails.mode}}'"
                        (mouseover)="hoveringMethod(rowIndex)"
                        (mouseleave)="hoveringVal()"
                      >{{memberDetails.status}}
                        <div class="checkiconStyle">
                          <div>
                            <span>
                              <div class="alignnIcon">
                                <div class="DocIconStyle" >
                                  <span
                                    data-bs-toggle="collapse"
                                    [attr.data-bs-target]="'#demo' + rowIndex" 
                                  >
                                    <i
                                      class="fa fa-file-text-o completeCheck"
                                      (click)="
                                        showDoc(
                                          rowIndex,
                                          memberDetails.memberHmoID
                                        )
                                      "
                                    ></i>
                                  </span>
                                </div>
                              </div>
                            </span>
                          </div>
                        </div>
                        <div class="checkiconStyle">
                          <div>
                            <span>
                              <div class="alignnIcon1">
                                <i class="fa fa-upload fileupload" (click)="uploadDocuments(rowIndex,memberDetails.memberHmoID)"></i>
                              </div>
                            </span>
                          </div>                          
                        </div>
                      </td>   

                      <td 
                      *ngIf="memberDetails.status === 'On Hold - Missing claim'"
                      style="cursor: pointer;text-align: left;width: 20%;" class="status-line-Red"
                      data-toggle="tooltip" title={{memberDetails.mode}}
                        (mouseover)="hoveringMethod(rowIndex)"
                        (mouseleave)="hoveringVal()"
                      >{{memberDetails.status}}
                        <div class="checkiconStyle">
                          <div>
                            <span>
                              <div class="alignnIcon">
                                <div class="DocIconStyle" >
                                  <span
                                    data-bs-toggle="collapse"
                                    [attr.data-bs-target]="'#demo' + rowIndex" 
                                  >
                                    <i
                                      class="fa fa-file-text-o completeCheck"
                                      (click)="
                                        showDoc(
                                          rowIndex,
                                          memberDetails.memberHmoID
                                        )
                                      "
                                    ></i>
                                  </span>
                                </div>
                              </div>
                            </span>
                          </div>
                        </div>
                      </td>  

                      <td 
                      *ngIf="memberDetails.status === 'On Hold - Non-AWV Claim'"
                      style="cursor: pointer;text-align: left;width: 20%;" class="status-line-Orange"
                      data-toggle="tooltip" title={{memberDetails.mode}}
                        (mouseover)="hoveringMethod(rowIndex)"
                        (mouseleave)="hoveringVal()"
                      >{{memberDetails.status}}
                        <div class="checkiconStyle">
                          <div>
                            <span>
                              <div class="alignnIcon">
                                <div class="DocIconStyle" >
                                  <span
                                    data-bs-toggle="collapse"
                                    [attr.data-bs-target]="'#demo' + rowIndex" 
                                  >
                                    <i
                                      class="fa fa-file-text-o completeCheck"
                                      (click)="
                                        showDoc(
                                          rowIndex,
                                          memberDetails.memberHmoID
                                        )
                                      "
                                    ></i>
                                  </span>
                                </div>
                              </div>
                            </span>
                          </div>
                        </div>
                      </td>  


                      <td 
                      *ngIf="memberDetails.status === 'Paid'"
                      style="cursor: pointer;text-align: left;width: 20%;" class="status-green"
                      data-toggle="tooltip" title={{memberDetails.mode}}
                        (mouseover)="hoveringMethod(rowIndex)"
                        (mouseleave)="hoveringVal()"
                      >{{memberDetails.status}}<i
                      class="fa fa-check-circle completeCheck completeCircle"
                    ></i>
                        <div class="checkiconStyle">
                          <div>
                            
                            <span>
                              <div class="alignnIcon">
                                <div class="DocIconStyle" >
                                  <span
                                    data-bs-toggle="collapse"
                                    [attr.data-bs-target]="'#demo' + rowIndex" 
                                  >
                                    <i
                                      class="fa fa-file-text-o completeCheck"
                                      (click)="
                                        showDoc(
                                          rowIndex,
                                          memberDetails.memberHmoID
                                        )
                                      "
                                    ></i>
                                  </span>
                                </div>
                              </div>
                            </span>
                          </div>
                        </div>
                      </td>   
                      <td *ngIf="memberDetails.status === 'Provider feedback'"></td>

                      <!-- <td 
                      *ngIf="memberDetails.status === 'Provider feedback'"
                      style="cursor: pointer;text-align: left;width: 20%;" class="status-line"
                      data-toggle="tooltip" title={{memberDetails.mode}}
                        (mouseover)="hoveringMethod(rowIndex)"
                        (mouseleave)="hoveringVal()"
                      >{{memberDetails.status}}
                        <div class="checkiconStyle">
                          <div>
                            <span>
                              <div class="alignnIcon">
                                <div class="DocIconStyle" >
                                  <span
                                    data-toggle="collapse"
                                    [attr.data-target]="'#demo' + rowIndex" 
                                  >
                                    <i
                                      class="fa fa-file-text-o completeCheck"
                                      (click)="
                                        showDoc(
                                          rowIndex,
                                          memberDetails.memberHmoID
                                        )
                                      "
                                    ></i>
                                  </span>
                                </div>
                              </div>
                            </span>
                          </div>                          
                        </div>
                        <div class="checkiconStyle">
                          <div>
                            <span>
                              <div class="alignnIcon1">
                                <i class="fa fa-upload fileupload" (click)="uploadDocuments(rowIndex,memberDetails.memberHmoID)"></i>
                              </div>
                            </span>
                          </div>                          
                        </div>

                        
                      </td>    -->

                      <td
                        *ngIf="!memberDetails.status"
                        style="cursor: pointer;text-align: left">
                        {{memberDetails.status}}
                        <!-- <i class="fa fa-flag noStatus"></i> -->
                      </td>
                      <td>{{memberDetails.statusDate}}</td>
                      <td>{{memberDetails.refreshStatus}}</td>
                      <!-- <td align="center"><i class="fa fa-download"></i></td>
                  <td align="center" class="notesStyle">
                    <textarea
                      class="areaStyle"
                      contenteditable="true"
                      style="resize: none"
                      placeholder="Add Notes"
                      maxlength="500"
                    ></textarea>
                  </td> -->
                    </tr>
                  </ng-container>
                  <ng-template #noMemberDetails
                    ><tr>
                      <td colspan="9">{{ memberDetails }}</td>
                    </tr></ng-template>

                  <tr *ngIf="rowIndex ==indexOfClickedRow"
                    id="{{ 'demo' + rowIndex }}"
                    class="collapse rows showRows innerRows parentTable parentTableForTabs"
                  >
                    <td class="hiddenRow noContent" colspan="6">
                      <div class="openPaneStyle">
                        <p class="headingstyle ">
                          LIST OF SUBMITTED DOCUMENTS
                        </p>
                        <div
                          class="table-wrapper-scroll-y admit-discharge-table my-custom-scrollbar subTable"
                        >
                          <table
                            class="table custom-table tableShadow stcikyHeaders pagingTable"
                            id="inpatientAdmissionTable"
                            style="width: 75%"
                          >
                            <thead class="hideInMobile">
                              <tr class="table-header">                                
                                <th>Document Name</th>
                                <th>Document Type</th>
                                <th>Date Uploaded</th>
                                <th style="width:25%">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container *ngIf="documentLoading; else nodocumentLoading">
                            <tr>
                              <td colspan="6" class="text-center-loading">
                                <img class="loader-symbol" src="../../assets/images/loading.gif">      
                              </td>
                            </tr>
                          </ng-container>
                              <!-- <ng-container *ngFor="let inpatient of inPatientData | dateFormatPipe:oneWeekdate():todaydate():'inPatient'"> -->
                              <ng-template #nodocumentLoading>
                              <!-- <ng-container
                              *ngFor="let inpatient of inPatientData | dateFormatPipe:oneWeekdate():todaydate():'inPatient';let i = index"> -->
                              <ng-container
                                *ngIf="
                                  AllDocuments.length >= 1;
                                  else noDocs
                                "
                              >
                                <ng-container
                                  *ngFor="
                                    let each of AllDocuments;
                                    let i = index
                                  "
                                >
                                  <tr class="flexColumn preTable">                                    
                                    <th>Document Name</th>
                                    <td>
                                      <span *ngIf="each?.docExtension == 'pdf' || each?.docExtension == 'PDF'">
                                        <i
                                          class="fa fa-file-pdf-o doc-icon"
                                        ></i>
                                      </span>
                                      <span
                                        *ngIf="each?.docExtension == 'docx' || each?.docExtension == 'doc' ||each?.docExtension == 'DOC'||each?.docExtension == 'DOCX'">
                                        <i
                                          class="fa fa-file-word-o doc-iconword"
                                        ></i>
                                      </span>
                                      {{ each?.docTitle }}
                                    </td>
                                    <th>Document Type</th>
                                    <td>
                                      {{ each?.docType }}
                                    </td>
                                    <th>Date Uploaded</th>
                                    <td>
                                      {{ each?.createdDate }}
                                    </td>
                                    <th>Actions</th>
                                    <td>
                                      <i
                                        class="fa fa-download" style="padding: 10px;"
                                        (click)="getDocument(each)"
                                      ></i>
                                      <i class="fa fa-eye" style="padding: 10px;" (click)="showPdfDocument(each)"></i>
                                      <ng-container *ngIf="calculateDiff(each?.createdDate) == 0">
                                        <i class="fa fa-trash" style="padding: 10px;" (click)="showDeleteModal(each?.docId,memberDetails.pcpName)"></i>
                                      </ng-container>
                                      
                                    </td>
                                  </tr>
                                </ng-container>
                              </ng-container>
                              <ng-template #noDocs
                                ><tr >
                                  <td colspan="6"> No Documents found </td>
                                </tr></ng-template
                              >

                              </ng-template>
                            </tbody>
                          </table>
                        </div>

                        <div
                          class="closeBtn closeBtnStyle"
                          data-toggle="collapse"
                          [attr.data-target]="'#demo' + rowIndex"
                        >
                        <!-- <ng-container *ngIf="memberDetails.status !== 'Paid' && memberDetails.status !== 'PAHAF approved'">
                          <button class="btn" (click)="uploadDocuments(rowIndex,memberDetails.memberHmoID)" style="margin-left: -160px">Upload documents</button>
                        </ng-container>                        -->
                        <ng-container *ngIf="memberDetails.status == 'Pending Coder Review' && uploadDocumentFlag == true">
                          <button class="btn" (click)="uploadDocuments(rowIndex,memberDetails.memberHmoID)" style="background-color: #23499E;margin-top: 8px; color: white;">Upload documents</button>
                        </ng-container>                       
                          <button
                            class="btn"
                            (click)="closeExpandedRow(rowIndex)"
                          >
                            X
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
          <div align="center" class="viewMoreBtn">
            <div colspan="9">
              <button
                id="displays"
                (click)="loadmoreData()"
                class="viewMoreDisplay"
              >
                View More
              </button>
              <!-- <button id="searchInputDisplay" class="viewMoreDisplay searchInputViewMore">View More</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
   
    
</div>
<div class="modal fade" id="previewPDF" role="dialog">
  <div class="modal-dialog" style="margin-right: 0px;
  margin-left: 11%;">
    <div class="modal-content" style="width:234%">
      <div class="modal-header" style="background-color: white;">
        <div>
          <span (click)="downloadAsPDF()" style="cursor: pointer;">
            <img class="downloadIcon change-my-color" src="../../../assets/images/download-btn.png" alt="pdf Icon">
        </span>
        <span class="downloadTextStyle1">
          Click here for download - Print
        </span>
          </div>
        <button type="button" style="color:none" class="btn-close" data-bs-dismiss="modal">
        </button>
      </div>
      <div class="modal-body" style="border: 7px solid white;height: 38em;">
        <ngx-loading
          [show]="modalLoading"
          [config]="{ backdropBorderRadius: '14px' }"
        ></ngx-loading>
        <div class="mainPdfBody"  >
      <ng-container *ngFor="
      let each of modalRenderList;
      index as pdfIndex
    ">
    <!-- <button type="button" (click)="generatePdf()" >
      PRINT PDF
     </button> -->
     <div id="canvasWrap">
        <div  id ="{{'pahafPDF' + pdfIndex}}" ><app-pahaf-form [parentValue]='each' (formLoaded)="onFormLoaded()" (formError)="onFormError()"></app-pahaf-form>
          <!-- <div #pahafPDF id ="pahafPDF" ><app-pahaf-form [parentValue]='parentValue'></app-pahaf-form> -->
        </div>
      </div>
      </ng-container>
        </div>
      </div>
      <!-- <div class="modal-footer">
        <div class="container-contact100-form-btn">
          <button
            type="button"
            class="btn btn-primary buttonInfo"
            data-dismiss="modal"
          >
            Close
          </button>
        </div>
      </div> -->
    </div>
  </div>
</div>

  <div class="modal fade " id="confirmModal1" role="dialog">
  <div class="modal-dialog" style="margin-top: 15%;">
    <div class="modal-content">
      <div class="modal-header no-border">
        <h5 class="modal-title">Confirm BULK PDF Generation</h5>
        <button type="button" class="btn-close op-1-0" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
      </div>
      <div class="modal-footer no-border" style="justify-content: center">
        <div class="container-contact100-form-btn">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="carelon-btn" (click)="chunkDownload()" data-bs-dismiss="modal">Confirm</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="confirmModal" role="dialog" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg" style="margin-right: 0px;
  margin-left: 12%; top:-20px">
    <div class="modal-content" style="width:140%">
      <div class="modal-header" style="background-color: white;">
        <div style="display: contents;">
          <span class="downloadTextStyle">
            BULK PDF Generation
          </span>          
          </div>
        <button type="button" style="color:none" class="btn-close" data-bs-dismiss="modal" id = "close_model_chart"  (click)="closeChartModal()">
        </button>
      </div>

      <div class="modal-body">
        <app-pahaf-bulk-download *ngIf="isBulkDownloadModalOpen" [memberData]="memberdetailsPdfData"></app-pahaf-bulk-download>
      </div>

      <div class="modal-footer no-border" style="justify-content: center">
        <div class="container-contact100-form-btn">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeChartModal()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade uploadFilledDocumentsicon" id="uploadFilledDocuments" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content content-style">
      <div class="modal-header uploadFilledDocument" >
        
        Upload Document
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" [disabled]="isUploadLoading">
        </button>
      </div>
      <div class="modal-body newFont" style="overflow-y: auto;
      overflow-x: auto; color: #231E33">
        <p>Please select one of the following options to upload both <b>PAHAF and Medical record/chart</b> documents.</p>
      <div class="row">
        
        <div class="col-md-6">
          <input #variable3 (change)="this.onFilechange1($event)" type="radio" name="foo" [(ngModel)]="radioBtn" value="multiple" class="radioColor" [disabled]="isUploadLoading"> Upload individual Documents <br> <br>
          <div style="color:#231E33">Select this option if you have PAHAF and Medical record/chart documents as separate documents</div>
        </div>
        <div class="col-md-6">
          <input #variable4 (change)="this.onFilechange2($event)" type="radio" name="foo" [(ngModel)]="radioBtn" value="single" class="radioColor" [disabled]="isUploadLoading"> Upload Consolidated Document<br> <br>
          <div style="color:#231E33; margin-top: -2px;">Select this option when the PAHAF and Medical record/chart documents are being submitted as one combined single document</div>
          
        </div>
      </div>
                                   
        <ng-container *ngIf="radioBtn == 'multiple'">
          <br>
          
            <!-- Upload Multiple File:<input (change)="this.uploadMultiple($event)" multiple placeholder="upload multiple file" class="form-control" type="file" id="formFile"> -->
            <table style="width: 75%;">
              <tr class="uploadDocumentStyleTr">
                <td class="uploadDocumentStyleTd required-field">PAHAF Document</td>
                <td class="uploadDocumentStyleTd">
                  <input #variable (change)="this.onFilechange($event,'PAHAF')" type="file" id="formFile1" name="formFile1" class="filepicker" accept=".pdf,.docx, .doc" [disabled]="isUploadLoading"/> {{Pahaffile}}</td>
              </tr> <br>
              <tr class="uploadDocumentStyleTr">
                <td class="uploadDocumentStyleTd required-field">Medical record/chart</td>
                <td class="uploadDocumentStyleTd">
                  <input #variable1 (change)="this.onFilechange($event,'Chart')" type="file" id="formFile2" name="formFile2" class="filepicker" accept=".pdf,.docx, .doc" [disabled]="isUploadLoading"/> {{Chartfile}}
                </td>
              </tr>
            </table>

            <div class="modal-footer">
              <button type="button" class="btn carelon-btn min-width no-hover" data-bs-dismiss="modal" [disabled]="isUploadLoading">Close</button>
              <button type="button" (click)="uploadFiles(uploadmemid)" style="background-color: #23499E; color: white;" class="btn carelon-btn min-width" 
              [disabled]="uploadFlag || isUploadLoading">Upload</button>        
            </div>
        </ng-container>

        <ng-container *ngIf="radioBtn == 'single'">
          <br>
          <br>
          <!-- Upload Single File: <input (change)="this.onFilechange($event)" placeholder="upload Single file" class="form-control" type="file" id="formFile"> -->
          <table style="width: 75%;">
            <tr class="uploadDocumentStyleTr">
              <td class="uploadDocumentStyleTd required-field">Consolidated Pahaf and <br>Medical record/chart documents</td>
              <td class="uploadDocumentStyleTd">
                <input #variable2 (change)="this.onFilechange($event,'PAHAF/Chart')" type="file" id="formFile3" name="formFile3" class="filepicker" accept=".pdf,.docx, .doc" [disabled]="isUploadLoading"/> {{PahafChartfile}}</td>
            </tr>
          </table>
          <div class="modal-footer">
            <button type="button" class="btn carelon-btn min-width" data-bs-dismiss="modal" [disabled]="isUploadLoading">Close</button>
            <button type="button" (click)="uploadFiles(uploadmemid)" style="background-color:#23499E;color: white;" class="btn carelon-btn min-width" 
            [disabled]="uploadFlag1 || isUploadLoading">Upload</button>        
          </div>
      </ng-container>   
        <div *ngIf="isUploadLoading" class="d-flex justify-content-center align-items-center py-3">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Uploading...</span>
        </div>
        <span class="ms-2">Uploading, please wait...</span>
      </div>     
      </div>

      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
        <button type="button" (click)="uploadFiles(uploadmemid)" class="btn btn-primary" 
        data-dismiss="modal" [disabled]="uploadFlag">Upload</button>        
      </div> -->
      
    </div>
  </div>
</div>

<div class="modal fade" id="docErrorModal" role="dialog">
	<div class="modal-dialog">
	  <div class="modal-content">
		<div class="modal-header">
      Upload Failed
      
		  <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
		</div>
		<div class="modal-body">
		  <p style="text-align:center;">Uploading document failed, please try again.</p>
		</div>
		<div class="modal-footer">
		  <div class="container-contact100-form-btn">
			<button type="button"class="btn carelon-btn buttonInfo" data-bs-dismiss="modal">Close</button>
		  </div>
		</div>
	  </div>
	</div>
</div>

<div class="modal fade documentsPageModal" id="deleteModal" role="dialog">
	<div class="modal-dialog">
	<div class="modal-content">
		<div class="modal-header" style="background-color:white">
		<h4 style="color: #23499E;font-size: 20px;font-weight: bold;">Delete Document</h4>
    
		<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
		</div>
		<div class="modal-body">
		<p>Do you really want to delete the file?</p>
		</div>
		<div class="modal-footer">
		<div class="container-contact100-form-btn d-flex justify-content-center">
			<button type="button"class="btn carelon-btn buttonInfo me-2" data-bs-dismiss="modal" (click)="deleteDocument(fileId,deleteprvname)">Yes</button>
			<button type="button"class="btn carelon-btn buttonInfo" data-bs-dismiss="modal">No</button>
		</div>
		</div>
	</div>
	</div>
</div>

<div class="modal fade" id="previewChart" role="dialog">
  <div class="modal-dialog modal-lg" style="margin-right: 0px;
  margin-left: 12%; top:-20px">
    <div class="modal-content" style="width:140%">
      <div class="modal-header" style="background-color: white;">
        <div style="display: contents;">
          <span class="downloadTextStyle">
            PAHAF Status
          </span>          
          </div>
        <button type="button" style="color:none" class="btn-close" data-bs-dismiss="modal" id = "close_model_chart"  (click)="closeChartModal()">
          <!-- &times; -->
        </button>
      </div>
      <div class="modal-body" style="height: 46em;">
        <div class="mainPdfBody"  >
      <ng-container>
     <div id="canvasWrap">
        <!-- <div  id ="{{'pahafPDF' + pdfIndex}}" ><app-pahaf-form [parentValue]='each'></app-pahaf-form>            
        </div> -->
        <div>
          <app-pahaf-chart [uname]="username"></app-pahaf-chart>
        </div>

      </div>
      </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="noStatus" role="dialog">
  <div class="modal-dialog" style="margin-top: 15%">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <p class="statusStyle">No pahaf status available for this member</p>
      </div>
      <div class="modal-footer">
        <div class="container-contact100-form-btn">
          <button
            type="button"
            class="btn carelon-btn buttonInfo"
            data-bs-dismiss="modal"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="PCPModal" role="dialog">
  <div class="modal-dialog" style="margin-top: 15%">
    <div class="modal-content">
      <div
        class="modal-header reportHeader"
        style="border-bottom: 0px; background-color: #23499E"
      >
        <span class="ui-dialog-title rosterTitle">Roster Forms</span>
        <button
          type="button"
          class="close closeGen"
          (click)="closeGenerate()"
          data-bs-dismiss="modal"
        >
        </button>
      </div>
      <div class="modal-body progressBarContainer displayRadio">
        <form [formGroup]="RosterForm">
          <div class="frameRadioStyle">
            <label>
              <input
                type="radio"
                value="1"
                formControlName="rosterType"
                (click)="clickedMemberRoster($event.target.value)"
              />
              <span>Member Roster</span>
            </label>
            <!-- <label>
              <input
                type="radio"
                value="2"
                formControlName="rosterType"
                (click)="clickedPCPValues($event.target.value)"
              />
              <span>Pending PAHAF Form by PCP </span>
            </label> -->
          </div>
        </form>
        <div class="drpdownoutside" *ngIf="disableDropdown">
          <span class="dropDownstyle" style="padding-top: 10px">
            <span class="labelStyle">PCP :</span>
            <!-- <p-dropdown
              [options]="providerIds"
              [(ngModel)]="selectedids"
              placeholder="Select Pcp Names"
              optionLabel="name"
              required="true"
              [style]="{ width: '50%' }"
              [autoWidth]="false"
              (onChange)="onPcpChange($event)"
            >
            </p-dropdown> -->
          <form>
            <select class="form-control selectDropStyle"  [(ngModel)]="selectedids" name="selectedids"  width="300"
                      style="width:300px" [ngClass]="!providerIds || providerIds.length == 0? 'disableDropDown':''"
                     (change)="onPcpChange($event)" required >
										<option [ngValue]="undefined" hidden selected>Select PCP Names</option>
                      <option style="height:350px;"*ngFor="let item of providerIds" [value]="item.code">{{item.name}}[{{item.address}}]</option>
                  </select>
                </form>
          </span>
          <span *ngIf="errorForCriteria" class="errrmsg"
            >No results found for search criteria
          </span>
        </div>
        <!-- <ng-progress [positionUsing]="'marginLeft'" [minimum]="0.1" [maximum]="1"  [speed]="200" [showSpinner]="true" [direction]="'rightToLeftIncreased'"
        [color]="'#1b5b98'" [trickleSpeed]="250" [thick]="true" [ease]="'linear'"></ng-progress> -->
      </div>

      <div class="ReportButton">
        <div class="container-contact100-form-btn">
          <button
            type="button"
            class="btn carelon-btn buttonInfo"
            [disabled]="generateButtonFlag"
            (click)="generateRosterDoc()"
          >
            Generate Report
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade alerts" data-backdrop="false" id="Alertdialogpahaf" role="dialog">
  <div class="modal-dialog modal-lg"  style="margin-top: 10%; margin-left: 19%" >
    <div class="modal-content">
      <div
        class="modal-header"
        style="border-bottom: 0px;">
        <span class="ui-dialog-title notificatinTitle">Unread Notifications</span>

        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body alertsBody">
        <div
            class="AlertView"
          >
            <app-tab-selection-pane
              (newTabValues)="addItem($event)"
              [selectedTabIndex]="selectedTab"
              [cardData]="cardData"
              [unReadHighAlertCount]="unreadHighCount"
              [unReadMedAlertCount]="unreadMedCount"
              [unReadLowAlertCount]="unreadLowCount"
              (flagValues)="setFlag($event)"
            ></app-tab-selection-pane>
            <div class="cardScrollableArea">
              <div *ngIf="selectedTab === 3">
                <!-- <div class="emergencyClass"> 
                          <div class="fontforEme">EMERGENCY</div>
                          <div class="viewStyle" (click)="checkEmergency()">view all</div>
                         
                        </div> -->

                <div *ngFor="let item2 of cardData">
                  <div
                    *ngIf="
                      item2 &&
                      (item2.IsUnRead === '1' ||
                        (item2.newelyAdded && item2.IsUnRead === '0'))
                    "
                  >
                    <app-cards
                      [item]="item2"
                      (click)="getStatusAlert(item2)"
                      (markAsReadAlert)="addMarkAsRead($event)"
                    ></app-cards>
                  </div>
                </div>

                <div *ngIf="isUnReadValue">
                  <p class="noAlerts">No Notifications Found</p>
                </div>

                <!-- <div class="nonemergencyClass"> 
                          <div class="fontFornonEme">NON EMERGENCY</div>
                          <div class="viewStyle" (click)="checkNonEmergencyTab()">view all</div>
                        </div>
                        <div *ngFor="let item2 of cardData.slice(0,4)">
                          <div *ngIf="item2.type === 'non-emergency'">
                            <app-cards [item]="item2"></app-cards>
                          </div>
                        </div> -->
              </div>

              <!-- only emetab -->
              <div *ngIf="selectedTab === 0">
                <div>
                
                  <div *ngFor="let itemcardforeme of cardData">
                    <div
                    *ngIf="
                    itemcardforeme &&
                      (itemcardforeme.IsUnRead === '1' ||
                        (itemcardforeme.newelyAdded && itemcardforeme.IsUnRead === '0'))
                    "
                  >
                    <div *ngIf="itemcardforeme.Severity.toLowerCase() === 'high'">
                      <app-cards [item]="itemcardforeme" (click)="getStatusAlert(itemcardforeme)"></app-cards>
                    </div>
                  </div>
                    
                  </div>
                  <div *ngIf="eachTabFlag && specificTabFlag || noCardFoundforHigh  ">
                    <p class="noAlerts">No Notifications Found</p>
                  </div>
                </div>
              </div>

              <!-- finish only emetab -->
              <!-- only nonemetab -->
              <div *ngIf="selectedTab === 1">
                <!-- <div>
                  <div class="fontFornonEme marginAfter">MEDIUM</div>
                </div> -->
                <div>
                  <div *ngFor="let itemcardfornon of cardData">
                    <div
                    *ngIf="
                    itemcardfornon &&
                      (itemcardfornon.IsUnRead === '1' ||
                        (itemcardfornon.newelyAdded && itemcardfornon.IsUnRead === '0'))
                    "
                  >
                    <div *ngIf="itemcardfornon.Severity.toLowerCase() === 'medium';else noMedumCard">
                    
                      <app-cards [item]="itemcardfornon" (click)="getStatusAlert(itemcardfornon)"></app-cards>
                      
                    </div>
                    </div>
                   
                  </div>
                  <div *ngIf="eachTabFlag && specificTabFlag || noDataFoundFlagMed">
                    <p class="noAlerts">No Notifications Found</p>
                  </div>
                </div>
                
              </div>
               <!-- finish only nonemetab -->
               <div *ngIf="selectedTab === 2">
                <!-- <div>
                  <div class="fontForlow marginAfter">LOW</div>
                </div> -->
                <div>
                  <div *ngFor="let itemcardfornon of cardData">
                    <div
                    *ngIf="
                    itemcardfornon &&
                      (itemcardfornon.IsUnRead === '1' ||
                        (itemcardfornon.newelyAdded && itemcardfornon.IsUnRead === '0'))
                    "
                  >
                    <div *ngIf="itemcardfornon.Severity.toLowerCase() === 'low'">
                      <app-cards [item]="itemcardfornon" (click)="getStatusAlert(itemcardfornon)"></app-cards>
                    </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="eachTabFlag && specificTabFlag || noDataFoundFlagLow ">
                  <p class="noAlerts">No Notifications Found</p>
                </div>
              </div>
            </div>

           
          </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade memberModal" id="errorGeneratePdf" role="dialog">
  <div class="modal-dialog" style="margin-top: 15%;">
    <div class="modal-content">
      <div class="modal-header no-border">
        <button type="button" class="btn-close op-1-0" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <p class="text-center margin0">{{displayErrMsg}}</p>
      </div>
      <div class="modal-footer no-border" style="justify-content: center">
        <div class="container-contact100-form-btn">
          <button type="button" class="carelon-btn" (click)="errorModal()" data-bs-dismiss="modal">OK</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="alertModal" role="dialog">
  <div class="modal-dialog" style="margin-top: 15%;">
    <div class="modal-content alertPopup">
      <div class="modal-header">
        
            <button type="button" class="btn-close"
              data-bs-dismiss="modal"></button>
          
      </div>
      <div class="modal-body">
        <div class="row imgContainer">
          <img style="width: 15%;" src="../../../assets/images/icons/Error.svg" alt="Success">
        </div>
        <p class="text">{{ message }}</p>
      </div>
      <div class="modal-footer">
        <div class="col-md-12 pl-0 d-flex justify-content-center">
          <button type="button" data-bs-dismiss="modal"
            class="btn carelon-btn">Close</button>
        </div>
      </div>
    </div>
  </div>

<div class="modal fade" id="alertModal" role="dialog">
  <div class="modal-dialog" style="margin-top: 15%;">
    <div class="modal-content alertPopup">
      <div class="modal-header">
        <div class="row">
          <div class="col-md-9">

          </div>
          <div class="col-md-3">
            <button type="button" class="close"
              data-bs-dismiss="modal"><img src="../../../assets/images/Close.svg"
                alt="close"></button>
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="row imgContainer">
          <img style="width: 15%;" src="../../../assets/images/icons/Error.svg" alt="Success">
        </div>
        <p class="text">{{ message }}</p>
      </div>
      <div class="modal-footer">
        <div class="col-md-12 pl-0" align="center">
          <button type="button" data-bs-dismiss="modal"
            class="btn carelon-btn">Close</button>
        </div>
      </div>
    </div>
  </div>

  </div>
  <div class="modal fade memberModal" id="errorGeneratePdf" role="dialog">
    <div class="modal-dialog" style="margin-top: 15%;">
      <div class="modal-content">
        <div class="modal-header no-border">
          <button type="button" class="close op-1-0" data-dismiss="modal"><img src = "../../../assets/images/Close.svg"></button>
        </div>
        <div class="modal-body">
          <p class="text-center margin0">{{displayErrMsg}}</p>
        </div>
        <div class="modal-footer no-border" style="justify-content: center">
          <div class="container-contact100-form-btn">
            <button type="button" class="carelon-btn" (click)="errorModal()" data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
<script>
  $(document).ready(function(){
    $('[data-toggle="tooltip"]').tooltip();   
  });
  </script>


<app-footer ></app-footer>

